import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getReceivedFeedbackTable } from 'services/continuousFeedback';

const getData = async ({ employeeId, offset, limit }) => {
  try {
    const res = await getReceivedFeedbackTable({
      employeeId,
      offset,
      limit,
    });
    const { columns = [], values = [] } = res ?? {};
    return { columns, values };
  } catch (err) {
    console.error('Error fetching feedback table data, err : ', err);
  }
  return null;
};

const useFeedbackReviewPeriodSummaryData = ({ employeeId, offset = 0, limit = 10 }) =>
  useQuery(
    [REACT_QUERY_KEYS.ReviewPeriodSummaryFeedback, employeeId, offset, limit],
    () =>
      getData({
        employeeId,
        offset,
        limit,
      }),
    { enabled: !!employeeId }
  );

export default useFeedbackReviewPeriodSummaryData;
